import styled from 'styled-components';
import { container } from 'theme';

export const StyledWrapperBG = styled.div`
  background: url('/images/magnets-bg.svg') no-repeat 0 100%;
  background-size: 25%;
  padding-bottom: 200px;

  @media (max-width: 768px) {
    background: none;
  }
`;

export const StyledMktText = styled.div`
  max-width: ${container('md')};
  width: 100%;
  margin: -6rem auto 0 auto;
  padding: 2rem;
  line-height: 1.5;
`;

export const StyledWrapper = styled.div`
  max-width: ${container('xl')};
  width: 100%;
  margin: 0 auto;
  flex: 1 1 auto;
  padding: 4rem 2rem 2rem 2rem;
  display: flex;
  gap: 4rem;

  .success,
  .form {
    flex: 1 1 55%;
  }

  .success {
    color: #837e93;
    text-align: center;
    width: 85%;
    align-self: flex-end;

    h2 {
      line-height: 1.2;
      margin: 0;
    }

    p {
      color: #333;
    }

    svg {
      color: #78d549;
    }
  }

  .content {
    > .wrapper {
      background: url('/images/magnets-onboarding-bg.png') no-repeat 0 100%;
      background-size: 100%;
      padding-bottom: 300px;
    }

    flex: 1 1 45%;

    h2 {
      line-height: 1.2;
      margin: 0;
    }

    p {
      margin-top: 0;
    }
  }

  @media (max-width: 768px) {
    background: none;
    flex-direction: column;

    .form,
    .content {
      flex: 0 0 auto;
    }
  }
`;
